<ps-ui-modal
  class="advance-targeting-modal"
  [ngClass]="{ 'adv-targeting-modal-class': form.value.qualification_name }"
>
  <ps-ui-modal-body class="pt-3 pb-0">
    <form [formGroup]="form">
      <div class="d-flex flex-wrap mb-5 justify-content-between">
        <div class="question-desc">Question Description:</div>
        <div class="align-self-center adv-dropdown">
          <div class="position-relative ques-desc">
            <label for="search" class="icon-pos">
              <i class="fa fa-search"></i>
            </label>
            <ng-select
              id="search"
              class="at-search-bar"
              placeholder="Start Typing..."
              (change)="selectQuestion($event)"
              [items]="questions"
              bindLabel="question_description"
              formControlName="qualification_name"
              [searchFn]="searchAdvanceQuestions"
              [readonly]="isQlcLiveSurvey"
            >
            </ng-select>
            <span class="browse-text">Browse</span>
          </div>
        </div>
      </div>
      <ng-container *ngIf="form.value.question_type">
        <div class="class-question-text">
          <span class="span-question-text">{{ form.value.questionText }}</span>
        </div>
        <div
          class="col-sm-4 col-md-6 input-answersObj"
          *ngIf="form.value.question_type !== 'range'; else rangeType"
        >
          <ng-select
            class="custom"
            placeholder="Pick Something"
            [clearable]="false"
            bindLabel="text"
            [multiple]="true"
            [items]="form.value.answers"
            [closeOnSelect]="false"
            formControlName="selectedAnswers"
          >
            <ng-template ng-header-tmp>
              <div class="button-advance-group">
                <button
                  class="btn btn-link advance-basic-button"
                  (click)="onSelectAll()"
                >
                  Select All
                </button>
                <button
                  class="btn btn-link advance-basic-button"
                  (click)="onClearAll()"
                >
                  Clear All
                </button>
              </div>
            </ng-template>
          </ng-select>
        </div>
        <ng-template #rangeType formGroupName="rangeSet">
          <div class="row custom_number">
            <div class="col-sm-4 col-md-4">
              <ps-ui-select-dropdown
                class="range-option"
                [field]="'text'"
                [dropdownItems]="rangeOptions"
                [enableSearch]="false"
                labelNone="Select Option"
                labelAlignment="start"
                [label]="form.controls.rangeOption.value?.text"
                (selectedItem)="setRangeOption($event)"
              ></ps-ui-select-dropdown>
            </div>
            <div
              class="col-sm-4 col-md-4"
              *ngIf="
                form.controls.rangeOption.value?.id === 'gt' ||
                form.controls.rangeOption.value?.id === 'bt'
              "
            >
              <input
                type="number"
                class="form-control"
                placeholder="Min"
                formControlName="from"
                psInputRestriction="[0-9]"
                oninput="if(this.value < 0){ this.value = '' }"
              />
            </div>
            <div
              class="col-sm-4 col-md-4"
              *ngIf="
                form.controls.rangeOption.value?.id === 'lt' ||
                form.controls.rangeOption.value?.id === 'bt'
              "
            >
              <input
                type="number"
                class="form-control"
                placeholder="Max"
                formControlName="to"
                psInputRestriction="[0-9]"
                oninput="if(this.value < 0){ this.value = '' }"
              />
            </div>
          </div>
        </ng-template>
      </ng-container>
      <button
        class="btn btn-info btn-lg adv-tar-button"
        psUiButton
        [outline]="true"
        (click)="applyTargeting()"
        [disabled]="question?.childs?.length ? true : false"
      >
        Apply Targeting
      </button>
    </form>
  </ps-ui-modal-body>
</ps-ui-modal>
